<h2>INSEGNI A SCUOLA?</h2>
<p> La De Cifris offre contenuti specifici pensati per gli insegnanti delle scuole superiori.
	Le iniziative ricoprono una vasta gamma di ambiti: consulta l'elenco
	seguente e scegli il ramo che più ti interessa.
</p>
<ul>
	<li>
		La De Cifris organizza una serie di iniziative divulgative volte a promuovere la conoscenza
		della crittografia anche in ambiti che esulano dalla ricerca. Consulta
		la <a routerLink="/iniziative-divulgative">
			pagina</a> dedicata e scopri di più al riguardo.
	</li>
	<li>
		La De Cifris si occupa, fra le varie cose, della creazione e
		gestione di riviste scientifiche di rilevanza internazionale. Scopri di
		più sul <a routerLink="/attivita">sito</a>.
	</li>
	<li>
		Tra le attività della De Cifris troviamo l'istituzione di seminari a tema crittografico,
		in particolare numerosi cicli di seminari a carattere tematico.
		Visita la <a routerLink="/seminariLocali">pagina</a> dedicata ai
		seminari e trova quelli che più ti interessano.
	</li>
</ul>